module.exports = __webpack_public_path__ + "img/geshihua.27f85c62.png";